import React from 'react';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import { _T } from 'appI18n';
import { appUrl } from 'utils';
const useStyles = makeStyles(theme => ({
    root: {
        textAlign: "center",
        marginBottom: 60
    },
    img: {
        fontSize: 200,
        // FIXME: hardcoded color.
        color: "#d7dee5",
    }
}), { name: "NoSearchResults" });
export default function NoSearchResults() {
    const classes = useStyles();
    return (React.createElement("div", { className: classes.root },
        React.createElement(Box, { textAlign: "center" },
            React.createElement(SearchOutlinedIcon, { fontSize: "inherit", className: classes.img })),
        React.createElement(Typography, { variant: "body1", component: "span" },
            _T.TOUR_NO_RESULTS,
            React.createElement("br", null),
            React.createElement(Link, { href: appUrl("/Tour") }, _T.TOUR_NO_RESULTS_SUBTEXT))));
}
